module.exports = __webpack_public_path__ + "static/lab2-096e0932282669ef8c9c3df2d82ba05f.jpg";